export default "__VITE_ASSET__CTv8zOiJ__"